import Block from "components/layout/block";
import { parse } from "lib/locale";
import { ListEntity } from "models/list-entity";
import { FunctionComponent, useEffect, useState } from "react";
import { useLocale } from "stores/hooks/locale";
import MultiListEntityTable from "./multi-list-entity-block-table";
import { useList } from "stores/hooks/list";
import { useListUser } from "stores/hooks/list-user";
import { adminDoGetEntityCollections } from "services/admin/list-user-entity-collection";
import { EntityCollection } from "models/list-user-entity-collection";

interface MultiListEntityProps {
  listEntity: ListEntity;
}

const MultiListEntity: FunctionComponent<MultiListEntityProps> = ({
  listEntity,
}) => {
  const locale = useLocale();
  const list = useList();
  const listUser = useListUser();
  const [entityCollections, toggleEntityCollections] = useState<
    EntityCollection[] | undefined
  >(undefined);

  const update = async () => {
    // get collections
    if (list && listUser) {
      const entityCollections = await adminDoGetEntityCollections(
        list.uuid,
        listUser.uuid,
        listEntity.uuid,
      );
      toggleEntityCollections(entityCollections);
    }
  };

  useEffect(() => {
    update();
  }, [list?.uuid, listUser?.uuid]);

  if (!list || !listUser || !entityCollections) {
    return null;
  }

  return (
    <Block title={parse(listEntity.name, locale)}>
      <MultiListEntityTable
        listEntity={listEntity}
        entityCollections={entityCollections}
        onUpdate={async () => update()}
      />
    </Block>
  );
};

export default MultiListEntity;
